import { removeCjelina, secondsToMinutesSeconds } from "@/utils/helpers";
import style from "./VideoEndOverlay.module.css";
import Icon from "@/ui/icon/Icon";
import Button from "@/ui/button/Button";
import { useEffect, useState } from "react";

function VideoEndOverlay({
	video,
	onReplay,
	onNext,
	nextUnit,
	nextUnitModule,
}) {
	const [progress, setProgress] = useState(0);

	useEffect(() => {
		const interval = setInterval(() => {
			setProgress((prev) => {
				if (prev >= 100) {
					clearInterval(interval);
					onNext?.();
					return 100;
				}
				return prev + 1;
			});
		}, 100);

		return () => clearInterval(interval);
	}, [onNext]);

	const timeLeft = Math.ceil(10 * (1 - progress / 100));

	return (
		<div
			className={style.videoOverlay}
			style={{ "--background": `url(${video.thumbnail})` }}
		>
			<div className={style.content}>
				<div className={style.title}>
					<div className={style.subtitle}>
						<Icon icon="fa-arrow-rotate-right" />
						<h3>Gledaj ponovo</h3>
					</div>
				</div>
				<div className={style.videoCard}>
					<div className={style.thumbnail}>
						<img
							onClick={onReplay}
							src={video.thumbnail}
							alt={video.name}
						/>
					</div>
					<div className={style.info}>
						<div className={style.module}>
							{removeCjelina(video.module.name)}
						</div>
						<div className={style.name}>{video.name}</div>
						<div className={style.duration}>
							{secondsToMinutesSeconds(video.duration)}
						</div>
					</div>
					<div className={style.action}>
						<Button className={style.btn} onClick={onReplay}>
							<Icon icon="fa-arrow-rotate-left" />
						</Button>
					</div>
				</div>

				{nextUnit && (
					<>
						<div className={style.title}>
							<div className={style.subtitle}>
								<Icon icon="fa-arrow-right" />
								<h3>
									{nextUnit?.unit_type == "quiz"
										? "Ispitajte znanje"
										: "Nastavite gledati"}
								</h3>
							</div>
							<span className={style.duration}>
								{secondsToMinutesSeconds(timeLeft)}
							</span>
						</div>
						<div className={`${style.videoCard} ${style.next}`}>
							{nextUnit?.unit_type == "video" ? (
								<div className={style.thumbnail}>
									<img
										onClick={onNext}
										src={nextUnit.thumbnail}
										alt={nextUnit.name}
									/>
								</div>
							) : (
								<div
									className={`${style.thumbnail} ${style.quiz}`}
								>
									<img
										onClick={onNext}
										src={video.thumbnail}
										alt={nextUnit.name}
									/>
									<div className={style.icoHolder}>
										<Icon
											iconType="fa-solid"
											icon="fa-question"
										/>
									</div>
								</div>
							)}
							<div className={style.info}>
								<div
									name={nextUnitModule?.name}
									className={style.module}
								>
									{removeCjelina(nextUnitModule?.name)}
								</div>
								<div
									name={nextUnit?.name}
									className={style.name}
								>
									{nextUnit?.name}
								</div>
								<div className={style.duration}>
									{nextUnit.unit_type == "quiz"
										? `${nextUnit?.question_count} pitanja`
										: nextUnit?.duration &&
										  secondsToMinutesSeconds(
												nextUnit.duration
										  )}
								</div>
							</div>
							<div className={style.action}>
								<Button className={style.btn} onClick={onNext}>
									<Icon
										icon={
											nextUnit?.unit_type == "video"
												? "fa-play"
												: "fa-arrow-right"
										}
									/>
								</Button>
							</div>

							<div className={style.progressBar}>
								<div
									className={style.progress}
									style={{ width: `${progress}%` }}
								></div>
							</div>
						</div>
					</>
				)}
			</div>
		</div>
	);
}

export default VideoEndOverlay;
